import React, {useState} from 'react';
import '../css/structure.css';
import { structures } from '../Data/structureList';
import { useTable } from "../hooks/useTable";
import AboonneTable from './AboonneTable';
// import { structures } from './../Data/structureList';


function StructureTable() {
  const [showAbonnes, setShowAbonnes] = useState(false);
  const [selectedStructure, setSelectedStructure] = useState(null);

  const handleShowAbonnes = (structure) => {
    setShowAbonnes(true);
    setSelectedStructure(structure);
  };
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 4;

  const { currentItems, filteredData, currentPage, paginate } = useTable(
    structures,
    itemsPerPage,
    searchTerm
  );
  
  return (
    <div className="structure-list">
      <h2>Liste des structures partenaire</h2>
      <div className="structure-cards">
        {currentItems.map((structure) => (
          <div key={structure.id} className="structure-card">
            <div className="structure-info">
              <img src={structure.logo} alt={structure.nom} className="logo" />
              <div className="structure-details">
                <h3><a onClick={() => handleShowAbonnes(structure)}>{structure.nom}</a></h3>
                <p>{structure.type}</p>
              </div>
            </div>
            <span className="amount">
              {structure.financement.reduce(
                (total, financement) => total + financement.nombreCartes,
                0
              )} abonnées
            </span>
          </div>
        ))}
      </div>
      <div className="pagination">
        <button 
          onClick={() => paginate(currentPage - 1)} 
          disabled={currentPage === 1}
        >
          Précédent
        </button>
        <span>Page {currentPage}</span>
        <button 
          onClick={() => paginate(currentPage + 1)} 
          disabled={currentItems.length < itemsPerPage}
        >
          Suivant
        </button>
      </div>
      {showAbonnes && (
        <div className="abonnes-modal">
          <div className="abonnes-modal-content">
            <AboonneTable structure={selectedStructure} />
            <button onClick={() => setShowAbonnes(false)}>Fermer</button>
          </div>
        </div>
      )}
    </div>
  )
}

export default StructureTable